export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-simple-maps/node_modules/d3-geo/src/identity.js
// module id = YMLj
// module chunks = 0